import styled from "styled-components";
import { fontBold } from "@tvg/atomic-ui/_static/Typography";
import TextAtom from "@tvg/atomic-ui/_atom/Text";
import TitleAtom from "../../_atom/Title";
import buildColor from "../../_static/ColorPalette";

export const Title = styled(TitleAtom)`
  && {
    font-family: ${fontBold};
    margin-bottom: 12px;
  }
`;

export const Text = styled(TextAtom)`
  display: flex;
  color: ${buildColor("grey", "800")};
  margin-bottom: 12px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  > div {
    width: 49%;
  }
`;

export const AddressFormContainer = styled.div`
  ${({ visible }) => (visible ? "" : "display: none;")}
  ${({ isLast }) => (isLast ? "margin-bottom: 24px;" : "")}
`;
